module.exports = __webpack_public_path__ + "img/40.5.COD.0fa52630.png";